function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Live"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60,10H4a3,3,0,0,0-3,3V43a3,3,0,0,0,3,3H23v2H19a1,1,0,0,0-.895.553l-2,4A1,1,0,0,0,17,54H47a1,1,0,0,0,.9-1.447l-2-4A1,1,0,0,0,45,48H41V46H60a3,3,0,0,0,3-3V13A3,3,0,0,0,60,10ZM3,13a1,1,0,0,1,1-1H60a1,1,0,0,1,1,1V39H3ZM45.382,52H18.618l1-2H44.382ZM39,48H25V46H39Zm22-5a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V41H61Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35,33H34a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38,30H25.647a9.8,9.8,0,0,0,.512-1H32a1,1,0,0,0,0-2H26.8A10,10,0,1,0,17,35H31a1,1,0,0,0,0-2H22.975a10.078,10.078,0,0,0,1.154-1H38a1,1,0,0,0,0-2Zm-15.293.293-1.622-1.622.8-4,2.909-1.455a7.917,7.917,0,0,1-1.971,7.247A.949.949,0,0,0,22.707,30.293ZM14.82,28,14.1,24.412,17,22.174l2.9,2.238L19.18,28ZM24.1,21.331l-2.987,1.494L18,20.419v-3.35A8.011,8.011,0,0,1,24.1,21.331ZM16,17.069v3.35l-3.114,2.406L9.9,21.331A8.011,8.011,0,0,1,16,17.069ZM9,25a7.966,7.966,0,0,1,.206-1.779l2.909,1.455.8,4-1.622,1.622a.949.949,0,0,0-.116.175A7.961,7.961,0,0,1,9,25Zm3.682,6.724c.007-.007.018-.009.025-.017L14.414,30h5.172l1.707,1.707c.007.008.018.01.025.017a7.944,7.944,0,0,1-8.636,0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39,26H37V21a1,1,0,0,0-2,0v6a1,1,0,0,0,1,1h3a1,1,0,0,0,0-2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42,20a1,1,0,0,0-1,1v6a1,1,0,0,0,2,0V21A1,1,0,0,0,42,20Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.316,20.051a1,1,0,0,0-1.265.633L47,23.838l-1.051-3.154a1,1,0,0,0-1.9.632l2,6a1,1,0,0,0,1.9,0l2-6A1,1,0,0,0,49.316,20.051Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55,22a1,1,0,0,0,0-2H52a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h3a1,1,0,0,0,0-2H53V25h1a1,1,0,0,0,0-2H53V22Z"
}));

var SvgLive = function SvgLive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/live.608b6495.svg";
export { ForwardRef as ReactComponent };